import React, { useState, useEffect } from 'react';

import api from 'services/api';

import { useDashboard } from 'containers/dashboard';
import { useDebounce } from 'hooks/useDebounce';

import Button from 'components/Button';
import Spinner from 'components/Spinner';
import GridFlex from 'components/GridFlex';
import { SmallSelect, Checkbox } from 'components/Fields';

import { WrapperSelect, WrapperButtonSelect, WrappCheckbox } from '../styles';

interface IList {
  id: number;
  name: string;
  type: string;
}

const filterType = 'materials';

const MaterialFilter: React.FC = () => {
  const [search, setSearch] = useState('');
  const [isInit, setIsInit] = useState(true);
  const [list, setList] = useState<IList[]>([]);
  const [loading, setLoading] = useState(false);

  const {
    data: {
      filters: {
        multiples: { materials },
      },
    },
    actions: { addToFilter, hasOnFilter, removeFilter, resetFilter },
  } = useDashboard();

  const getMaterials = async () => {
    if (isInit) {
      setIsInit(false);
      return;
    }

    setLoading(true);

    const newList: IList[] = await api.get(
      `/materials?isActive=1&name=${search}`,
    );
    setList(newList);

    setLoading(false);
  };

  const autoSave = useDebounce(search);

  const saveChange = async () => {
    getMaterials();
  };

  useEffect(() => {
    saveChange();
  }, [autoSave]);

  return (
    <WrapperSelect>
      <SmallSelect
        withInputSearch
        dataTest="select-test"
        inputSearchPlaceholder="Search"
        inputSearchOnChange={setSearch}
        inputSearchvalue={search}
        placeholder="Material name"
        numberSelected={Number(materials?.length)}
        maxHeight="270px"
        onOpen={() => !list.length && getMaterials()}
        auxiliaryButton={
          <WrapperButtonSelect>
            <Button
              data-testid="reset-filter"
              scheme="nobg"
              onClick={() => {
                setSearch('');
                resetFilter(filterType);
              }}
              padding="9px 20px"
            >
              Reset filters
            </Button>
          </WrapperButtonSelect>
        }
      >
        <>
          {loading ? (
            <GridFlex justifyContent="center" alignItems="center">
              <Spinner />
            </GridFlex>
          ) : (
            <WrappCheckbox>
              {list.map(item => (
                <Checkbox
                  key={`${filterType}-${item.name}-${item.type}-${item.id}`}
                  isChecked={hasOnFilter(filterType, item)}
                  label={item.name}
                  name={item.name}
                  onClick={() =>
                    !hasOnFilter(filterType, item)
                      ? addToFilter(filterType, item)
                      : removeFilter(filterType, item)
                  }
                  width="11px"
                  widthIcon="5px"
                  marginRightIcon="7px"
                  textFontSize={11}
                />
              ))}
            </WrappCheckbox>
          )}
        </>
      </SmallSelect>
    </WrapperSelect>
  );
};

export default MaterialFilter;
